import Api from 'src/util/api';
import { PageDo, Result, ResultPageDo, Integer, PageResDo } from 'src/types/base';
import { DateTimeUtil } from 'src/util/dateTimeUtil';


export namespace OriginalMessageDOI {
    export interface QueryRowDataParamsI extends PageDo {
        datatime?: string;
        cn?: string;
        pw?: string;
        mn?: string;
    }

    export interface RowDataI {
        data: string;
    }
}

export default class OriginalMessageApi {
    /**
     * 获取原始报文
     * @param params 
     */
    static async getOriginalMessage(params: OriginalMessageDOI.QueryRowDataParamsI): Promise<ResultPageDo<OriginalMessageDOI.RowDataI[]>>{
        return Api.post("/protocal/get/original/message", {
            cn:'',
            pw:'',
            mn:'',
            ...params,
            datatime: DateTimeUtil.formateDate(params.datatime, 'YYYY-MM-DD')
        });
    }
}